import { isDefined } from 'utils/tsHelpers';
import { IssueData, ZodIssueCode } from 'zod';
import { AnyComparator, RegexComparator } from '../../types';

const REGEX_CHARACTER_LIMIT = 30000;

export const validateRegexValue = (
  {
    value,
    comparatorType,
  }: Partial<{
    value: string;
    comparatorType: AnyComparator;
  }>,
  addIssue: (arg: IssueData) => void,
) => {
  const isRegexComparator =
    comparatorType === RegexComparator.CONTAINS || comparatorType === RegexComparator.MATCHES_REGEX;
  const isPastRegexCharacterLimit = isDefined(value) && value.length > REGEX_CHARACTER_LIMIT;
  if (isRegexComparator && isPastRegexCharacterLimit) {
    addIssue({
      code: ZodIssueCode.custom,
      message: `value surpasses regex limit of ${REGEX_CHARACTER_LIMIT}`,
      path: ['value'],
    });
  }
};
